// C5-9 (owner, 27 Sep 2026): each marketing view puts one asterisk on its
// most prominent "free" claim and carries this footnote once, in the line it
// annotates. A club taking payments through Tap Leagues pays a commission on
// each one, so an unqualified "free" would mislead.
// "Taken through Tap Leagues" (owner, 14 Oct 2026): a club collecting money any
// other way pays nothing, and the note has to say so.
export const COMMISSION_NOTE = '*2% + Stripe fees, only on payments taken through Tap Leagues.';
